import { createFileRoute } from "@tanstack/react-router";
import { SessionPaymentResult } from "@/components/booking/SessionPaymentResult";
import { parseSessionReturn } from "@/lib/payment-return-url";

// Monri return URL of a client booking. Our ids live in the path; the query
// string belongs to Monri and is ignored.
export const Route = createFileRoute("/booking/payment-result/$outcome/$session")({
  component: SessionPaymentReturn,
});

function SessionPaymentReturn() {
  const { outcome, session } = Route.useParams();
  return <SessionPaymentResult {...parseSessionReturn({ outcome, session })} />;
}
